
<mat-dialog-content class="mat-typography" >

  <input id="ScreenTitle" name="ScreenTitle" type="text" [(ngModel)] = "screenTitle" disabled  style="width: 100%;height: 30%;text-align: center;font-size: 2.5ch; background-color: rgb(92, 139, 226);">

  <BR>
  <BR>
  <BR>
<!---------From year to year --------->
  <form action="search-results.html" [hidden]= "yearVisable" method="get" style="width: 820px;" align="center">

        <label style="font-size: 2ch;"  >From Year  </label>
        <input id="fromDate" name="FromDate"   type="text" class="styled-input"  [(ngModel)]="fromDate"  style="width: 10%; font-size: 2ch;height: 40px;" maxlength="4ch" placeholder="----" >
        <label style="font-size: 2ch;"  >                  To Year  </label>
        <input id="toDate" name="toDate"  type="text"  [(ngModel)]="toDate" class="styled-input" style="width: 10%;font-size: 2ch;height: 40px;" maxlength="4ch"placeholder="----">

  </form>

<!---------From Date to Date --------->
  <form action="search-results.html"  [hidden]="dateVisable" method="get" style="width: 820px;"  align="center">
      <label>     </label>

          <label style="font-size: 2ch;"  >From Date  </label>
          <input id="fromDateF" name="fromDateD"  type="date" class="styled-input"  [(ngModel)]="fromDateD"  style="width: 30%; font-size: 2ch;height: 40px;" >
          <label style="font-size: 2ch;"  >     To Date  </label>
          <input id="toDateF" name="toDateD" type="date"    [(ngModel)]="toDateD" class="styled-input"  style="width: 30%;font-size: 2ch;height: 40px;">

  </form>
<BR>
<!---------Select Doctor --------->
<form action="search-results.html"  [hidden]="docVisable" method="get" style="width: 820px;"  align="center">

  <div class="w3l-hero-headers-11 p-sticky-md">
    <div class="styled-input">
      <form action="search-results.html" method="get">
      <label style="font-size: 2ch;"  >Doctor  </label>
      <select id="doctor" name="doctor" required="" [(ngModel)]="docCode" [value]="docName" style="width:50%;height: 40px;">
        <option value="{{doc.docCode}}"  *ngFor="let doc of doctorsList; let i = index">{{doc.docName}}</option>
    </select>
    </form>
    </div>
  </div>
</form>
<BR>
  <!---------Select Rooms --------->
  <form action="search-results.html"  [hidden]="roomVisable" method="get" style="width: 820px;"  align="center">

    <div class="w3l-hero-headers-11 p-sticky-md">
      <div class="styled-input">
        <form action="search-results.html" method="get">
        <label style="font-size: 2ch;"  >Room  </label>
        <select id="rooms" name="rooms" required="" [(ngModel)]="roomCode" [value]="roomCode" style="width:50%;height: 40px;">
          <option value="{{unit.roomCode}}" *ngFor="let unit of roomsList; let i = index">{{unit.roomName}}</option>
        </select>
        </form>
      </div>
    </div>
  </form>

  <BR>
    <!---------Select Protocols --------->
    <form action="search-results.html"  [hidden]="protocolVisable" method="get" style="width: 820px;"  align="center">

      <div class="w3l-hero-headers-11 p-sticky-md">
        <div class="styled-input">
          <form action="search-results.html" method="get">
          <label style="font-size: 2ch;"  >Protocol   </label>
          <select id="proto" name="proto" required="" [(ngModel)]="prHdCode" [value]="prHdCode" style="width:50%;height: 40px;">
            <option value="{{prot.prHdCode}}" *ngFor="let prot of protocolList; let i = index">{{prot.prHdName}}</option>
          </select>
          </form>
        </div>
      </div>
    </form>


  <BR>
<!---------Select Patient --------->
   <form  action="search-results.html"  [hidden]="patVisable" method="get" style="width: 820px;" align="center">
        <div class="w3l-hero-headers-11 p-sticky-md">
        <div class="search">
          <form action="search-results.html" method="get">
              <input id="search" name="search" type="text" [(ngModel)]="patientCode"
                  (change)="retrivePatients()" placeholder="Patient Code" style="width: 20%;">
              <input id="search" name="search" type="text" [(ngModel)]="patientFName"
                  (change)="retrivePatients()" placeholder="Patient Name">
              <input id="search" name="search" type="text" [(ngModel)]="telMobile"
                  (change)="retrivePatients()" placeholder="Mobile No.">
          </form>
      </div>
    </div>
      <table>
        <thead>
            <tr>
                <th>Patient ID</th>
                <th>Patient Name</th>
                <th>Cancer Type</th>
                <th>Mobile No.</th>
                <th>Choose</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let pa of patientList; let i = index">
                <td data-column="Patient ID">{{pa.patientCode}}</td>
                <td data-column="Patient Name">{{pa.patientFName}}</td>
                <td data-column="Cancer Type">{{pa.cancerID}}</td>
                <td data-column="Mobile No.">{{pa.telMobile}}</td>
                <td data-column="Choose"><button type="button" class="theme-button btn" name="submit" (click)="SelectPatient(pa)">Select</button>
                </td>
            </tr>
        </tbody>
      </table>
   </form>

    <!---------Select Cancer Type --------->
  <form action="search-results.html"  [hidden]="canVisable" method="get" style="width: 820px;"  align="center">

    <div class="w3l-hero-headers-11 p-sticky-md">
      <div class="styled-input">
        <form action="search-results.html" method="get">
        <label style="font-size: 2ch;width: 78px;"  >Cancer Type            </label>

        <select id="rooms" name="rooms" required="" [(ngModel)]="cancertype" [value]="cancertype" style="width:50%;height: 40px;">
          <option value="{{unit.cancerID}}" *ngFor="let unit of cancerlist; let i = index">{{unit.cancerName}}</option>
        </select>
        </form>
      </div>
    </div>
  </form>
    <!---------Select Mortality Reasons --------->
    <form action="search-results.html"  [hidden]="morVisable" method="get" style="width: 820px;"  align="center">

      <div class="w3l-hero-headers-11 p-sticky-md">
        <div class="styled-input">
          <form action="search-results.html" method="get">
          <label style="font-size: 2ch;width: 75px;"  >Mortality Reasons  </label>
          <select id="rooms" name="rooms" required="" [(ngModel)]="morreasons" [value]="morreasons" style="width:50%;height: 40px;">
            <option value="">Non</option>
            <option value="Palliative">Palliative</option>
            <option value="Disease related">Disease related</option>
            <option value="Treatment  related">Treatment  related</option>
            <option value="Co.Morbidity">Co.Morbidity</option>
            <option value="Others">Others</option>
          </select>
          </form>
        </div>
      </div>
    </form>
    <!---------Select Room Type --------->
    <form action="search-results.html"  [hidden]="roomtypebvisable" method="get" style="width: 820px;"  align="center">

      <div class="w3l-hero-headers-11 p-sticky-md">
        <div class="styled-input">
          <form action="search-results.html" method="get">
          <label style="font-size: 2ch;width: 75px;"  >Room Type         </label>
          <select id="roomstype" name="roomstype" required="" [(ngModel)]="roomtype" [value]="roomtype" style="width:50%;height: 40px;">
            <option value="Type">Type*</option>
            <option value ="Folllow up">Folllow up</option>
            <option value="Consultation">Consultation</option>
            <option value="Treatment">Treatment</option>
            <option value="Follow up Visit">Follow up Visit</option>
            <option value="Others">Others</option>
          </select>
          </form>
        </div>
      </div>
    </form>
  <BR>
  <BR>
  <BR>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <form  action="search-results.html"  [hidden]="buttVisable" method="get" style="width: 820px;" align="center">
  <button    class="theme-button btn" (click)="FunClose()">Cancel</button>
  <button   class="theme-button btn" (click)="ReportPrint(doctorSelectedData)" >Print</button>
  </form>
</mat-dialog-actions>
<BR>
<BR>



